import styled from 'styled-components';

export const MultiSelectStyle = styled.div`
  .custom-tag {
    background-color: var(--light-primary);
    color: var(--primary);
    border: none;
    padding: 5px 18px 5px 10px;
    border-radius: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    font-size: 12px;

    .anticon {
      color: var(--primary);
    }

    .tag-close-icon {
      cursor: pointer;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .tag-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 10px;
    gap: 10px;
  }
`;
